/**
 * @fileoverview Model representing the server response after requesting data
 *
 * @author Heesun Jun (hjun@yext.com)
 */
/** @template T */
export class ResponseError {
  /**
   * @param {{
   *  value: T?,
   *  hasError: boolean,
   *  customErrorMessage: string?,
   * }} params
   */
  constructor(params) {
    /** @type {T?} */
    this.value = params.value;
    /** @type {boolean} */
    this.hasError = params.hasError;
    /** @type {string?} */
    this.customErrorMessage = params.customErrorMessage;
  }

  /**
   * @param {ResponseErrorJson} json
   * @param {Function} valueFromJson
   * @return {!ResponseError}
   */
  static fromJSON(json, valueFromJson) {
    return new ResponseError({
      value: json['value'] ? valueFromJson(json['value']) : undefined,
      hasError: json['hasError'],
      customErrorMessage: json['customErrorMessage'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  value: ?,
 *  hasError: boolean,
 *  customErrorMessage: string?,
  * }}
  */
export var ResponseErrorJson;
